import { AfterViewInit, Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { PolicyContextService } from '@benefitsui/app/services/policy-context/policy-context.service';
import { TabComponent, TabsComponent } from '@dxo/ng-swift-ui';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-allforms-page',
  templateUrl: './forms-page.component.html',
  standalone: false,
  providers: [PolicyContextService, CommonModule]
})
export class AllFormsPageComponent implements AfterViewInit {
  @ViewChildren(TabComponent) tabs?: QueryList<TabComponent>;
  @ViewChild(TabsComponent) tabsComponent?: TabsComponent;

  constructor(private route: ActivatedRoute) {}

  ngAfterViewInit(): void {

    // we can default to a specific tab by passing the tab name in the URL
    const tabToSelect = this.route.snapshot.paramMap.get('tab')?.toLowerCase();
    if (tabToSelect) {
      const tab = this.tabs?.find((tab) => tab.header.toLowerCase() === tabToSelect);
      if (tab) {
        setTimeout(() => {
          this.tabsComponent?.selectTab(tab);
        });
      }
    }
  }
}
